import React from 'react'
import { t } from 'ttag'

import { Box } from 'components/layout/Box/Box'
import { Icon } from 'components/shared/Icon/Icon'
import { IconButton } from 'components/shared/IconButton/IconButton'

import {
  ChevronLeftIcon,
  ChevronRightIcon,
  MailIcon,
} from 'components/shared/Icon/model'

import styles from './SendTestsMessageHeader.module.scss'

export const SendTestsMessageHeader = ({
  currentStepIndex,
  steps,
  subtitle,
  onNextStep,
  onPreviousStep,
  isFirstStep,
  isLastStep,
}) => {
  const index = currentStepIndex + 1
  const count = steps.length

  return (
    <Box align="center" className={styles.header} justify="space-between">
      <Box align="center" className={styles.content}>
        <Icon className={styles.icon} icon={MailIcon} size={32} />
        <Box direction="column">
          <h3 className={styles.subtitle}>{subtitle}</h3>
          <h4 className={styles.count}>{t`Count: ${index} of ${count}`}</h4>
        </Box>
      </Box>
      {steps.length > 1 ? (
        <Box align="center" className={styles.actions}>
          <IconButton
            ariaLabel={t`Previous message`}
            className={styles.button}
            icon={ChevronLeftIcon}
            size="small"
            variant="text"
            onClick={onPreviousStep}
            isDisabled={isFirstStep}
          />
          <IconButton
            ariaLabel={t`Next message`}
            className={styles.button}
            icon={ChevronRightIcon}
            size="small"
            variant="text"
            onClick={onNextStep}
            isDisabled={isLastStep}
          />
        </Box>
      ) : null}
    </Box>
  )
}
